import { render, staticRenderFns } from "./train-cleaning-details.vue?vue&type=template&id=27fdfd5f&scoped=true"
import script from "./train-cleaning-details.vue?vue&type=script&lang=js"
export * from "./train-cleaning-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fdfd5f",
  null
  
)

export default component.exports